import type { AlertFormValues } from "./types";

export type AlertFieldKey = "origin" | "destination" | "departure" | "price";

/** Ordem em que os campos aparecem na barra (define o primeiro inválido). */
export const FIELD_ORDER: AlertFieldKey[] = [
  "origin",
  "destination",
  "departure",
  "price",
];

/** Mensagem exibida junto ao campo quando ele está pendente. */
export const REQUIRED_MESSAGES: Record<AlertFieldKey, string> = {
  origin: "Escolha de onde você vai partir.",
  destination: "Escolha para onde você quer ir.",
  departure: 'Escolha as datas ou marque "independente de datas".',
  price: "Informe o preço máximo.",
};

/** Nome do campo usado no resumo de pendências da barra. */
export const SUMMARY_LABELS: Record<AlertFieldKey, string> = {
  origin: "origem",
  destination: "destino",
  departure: 'datas de ida (ou marque "independente de datas")',
  price: "preço máximo",
};

/**
 * Valida os campos obrigatórios da criação de alerta.
 * @param values - Valores atuais do formulário.
 * @returns Mensagem por campo pendente (objeto vazio quando tudo está ok).
 */
export const validateCreateValues = (
  values: AlertFormValues,
): Partial<Record<AlertFieldKey, string>> => {
  const errors: Partial<Record<AlertFieldKey, string>> = {};
  if (!values.origin) errors.origin = REQUIRED_MESSAGES.origin;
  if (!values.destination) errors.destination = REQUIRED_MESSAGES.destination;
  if (!values.openDates && values.departureDates.length === 0)
    errors.departure = REQUIRED_MESSAGES.departure;
  if (values.priceCents <= 0) errors.price = REQUIRED_MESSAGES.price;
  return errors;
};
